import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import SEO from "@/components/SEO";
import { BLOG } from "@/data/blog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const [adminPosts, setAdminPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/blog`).then(({ data }) => {
      const mapped = (data.posts || []).map(p => ({ ...p, readTime: p.read_time }));
      setAdminPosts(mapped);
    }).catch(() => {});
  }, []);

  const all = [...adminPosts, ...BLOG];
  const [feature, ...rest] = all;
  return (
    <div data-testid="blog-page">
      <SEO
        title="Journal — Sanatan Dharma & Living"
        description="Notes on ritual, tradition and the modern Indian home. Read about kapoor, kalava, akhand jyot, havan and the meaning behind daily puja."
        keywords="sanatan dharma blog, puja rituals, importance of kapoor, meaning of kalava, daily puja guide, akhand jyot, havan significance, indian festivals"
        path="/blog"
      />
      <section className="mandala-bg border-b border-[#3B2A1A]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <SectionHeading overline="The Journal" title="Sanatan Dharma & Living." subtitle="Quiet, well-considered notes on ritual, tradition and the modern Indian home." />
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to={`/blog/${feature.slug}`} className="group grid lg:grid-cols-12 gap-10 lg:gap-16 items-center border-b border-[#3B2A1A]/10 pb-16" data-testid="blog-feature">
            <div className="lg:col-span-7 aspect-[4/3] overflow-hidden bg-[#F5EFE3]">
              <img src={feature.image} alt={feature.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1500ms]" />
            </div>
            <div className="lg:col-span-5">
              <p className="overline">{feature.category} · {feature.readTime}</p>
              <h2 className="font-serif-display text-4xl lg:text-5xl text-[#3B2A1A] mt-4 leading-[1.05]">{feature.title}</h2>
              <p className="text-base leading-relaxed text-[#5C4A3A] mt-5 font-light">{feature.excerpt}</p>
              <span className="mt-7 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#C89D3C]">Read article <ArrowRight size={14} /></span>
            </div>
          </Link>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 mt-20" data-testid="blog-grid">
            {rest.map((post) => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="group" data-testid={`blog-card-${post.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[#F5EFE3]">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1500ms]" />
                </div>
                <p className="overline mt-5 text-[10px]">{post.category} · {post.readTime}</p>
                <h3 className="font-serif-display text-2xl text-[#3B2A1A] mt-3 leading-tight">{post.title}</h3>
                <p className="text-sm text-[#5C4A3A] mt-2 font-light leading-relaxed">{post.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
